module.exports = __webpack_public_path__ + "static/media/HouseSmartTopVideoBackground.2fd20211.jpg";